import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Divider, Typography, TextArea } from '@telus-uds/components-web';
import axios from 'axios';

import OrderComments from './OrderComments';
import { Box } from '../../../design/css';
import { apiHost, config } from '../../../utils/request';
import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const Comments = ({ comment, setComment, orderId, activeButton }) => {
  const locale = useLocaleContext();
  const [addedComments, setAddedComments] = useState([]);
  const {
    DEFECT_MANAGEMENT: { COMMENTS, ADD_COMMENT }
  } = locale === 'en-US' ? EN : FR;

  const onChangeComment = (value) => {
    setComment(value);
    if (value.length !== 0) {
      activeButton(true);
    } else {
      activeButton(false);
    }
  };

  const getComments = () => {
    axios.get(`${apiHost}/orders/${orderId}`, config()).then(data => {
      setAddedComments(data.data.comments);
    });
  };

  useEffect(() => {
    getComments();
  }, []);

  return (
    <>
      <Divider space={2} variant={{ inverse: true }} />
      <Typography heading="h2" variant={{ size: 'h2' }} block>
        {COMMENTS}
      </Typography>
      <OrderComments data={addedComments} />
      <Box mt={10} />
      <TextArea
        label={ADD_COMMENT}
        value={comment}
        onChange={onChangeComment}
      />
    </>
  );
};

Comments.propTypes = {
  comment: PropTypes.string.isRequired,
  setComment: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired,
  activeButton: PropTypes.func.isRequired
};

export default Comments;
